import { inject, Injectable, signal } from '@angular/core';
import { CustomerDisplayData } from '../shared/models/route';
import { CustomerDisplayService } from '../shared/services/customer-display.service';

@Injectable()
export class CustomerDisplayPageService {
  customerDisplayService = inject(CustomerDisplayService);
  customerDisplayData = signal<CustomerDisplayData | null>(null);

  getRouteList(code: string) {
    this.customerDisplayService.getCustomerDisplayData(code).subscribe((data: CustomerDisplayData) => {
      this.customerDisplayData.set(data);
    });
  }
}
